import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/payroll-cycles',
    name: 'payroll-cycle',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/payroll-cycle/index.vue')
  }
]
